import { render, staticRenderFns } from "./InfoMessageModal.vue?vue&type=template&id=5b5e2596&"
import script from "./InfoMessageModal.vue?vue&type=script&lang=js&"
export * from "./InfoMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports